import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import watchBuyService from "./watchBuyService";

const errMsg = (error) =>
  error.response?.data?.message || error.message || "Something went wrong";

const bySort = (a, b) => a.sort_order - b.sort_order || b.id - a.id;

export const fetchWatchBuys = createAsyncThunk(
  "watchBuy/fetchAll",
  async (_, thunkAPI) => {
    try {
      return await watchBuyService.getAll(); // { data, products }
    } catch (error) {
      return thunkAPI.rejectWithValue({ message: errMsg(error) });
    }
  }
);

// formData ma "id" hoy to update, nahi to create
export const saveWatchBuy = createAsyncThunk(
  "watchBuy/save",
  async (formData, thunkAPI) => {
    try {
      return formData.get("id")
        ? await watchBuyService.update(formData)
        : await watchBuyService.create(formData);
    } catch (error) {
      return thunkAPI.rejectWithValue({ message: errMsg(error) });
    }
  }
);

export const deleteWatchBuy = createAsyncThunk(
  "watchBuy/delete",
  async (id, thunkAPI) => {
    try {
      await watchBuyService.remove(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue({ message: errMsg(error) });
    }
  }
);

const watchBuySlice = createSlice({
  name: "watchBuy",
  initialState: {
    list: [],
    products: [],
    isLoading: false,
    isError: false,
    message: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWatchBuys.pending, (s) => {
        s.isLoading = true; s.isError = false; s.message = "";
      })
      .addCase(fetchWatchBuys.fulfilled, (s, a) => {
        s.isLoading = false;
        s.list = a.payload.data || [];
        s.products = a.payload.products || [];
      })
      .addCase(fetchWatchBuys.rejected, (s, a) => {
        s.isLoading = false; s.isError = true;
        s.message = a.payload?.message || "Failed to load videos";
      })
      .addCase(saveWatchBuy.fulfilled, (s, a) => {
        const row = a.payload.data;
        const i = s.list.findIndex((x) => x.id === row.id);
        if (i >= 0) s.list[i] = row; else s.list.push(row);
        s.list.sort(bySort);
      })
      .addCase(deleteWatchBuy.fulfilled, (s, a) => {
        s.list = s.list.filter((x) => x.id !== a.payload);
      });
  },
});

export default watchBuySlice.reducer;